export default __webpack_public_path__ + "./images/pw.e7e90a19.png";